export enum NotificationStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED'
}
